<div class="wrap">
  <div class="header">
    <div class="title" [style.width.%]="isUpdate? 69 : 50">
      <fa-icon [icon]="getFaIcon('faChevronLeft')" [routerLink]="['/admin/structure']"
        routerLinkActive="router-link-active" *ngIf="!showEditStructure" appChangeColorTheme
        attribute="color"></fa-icon>

      <h2 *ngIf="!isUpdate">{{structure?.structureName}}</h2>

      <form [formGroup]="updateStructureForm" (ngSubmit)="onSubmit()" *ngIf="isUpdate">
        <mat-form-field appearance="outline">
          <mat-label>Nom de la structure</mat-label>
          <input matInput type="text" formControlName="structureName">
        </mat-form-field>

        <div class="btn_action">
          <button type="button" class="back" (click)="disabledUpdate()">Annuler</button>
          <button type="submit" class="confirm" [disabled]="updateStructureForm.invalid"
            [style.opacity]="updateStructureForm.invalid? .5 : 1" appChangeColorTheme
            attribute="bgc">Sauvegarder</button>
        </div>
      </form>
    </div>

    <div class="add_search_structure" [style.width.%]="isUpdate? 29 : 50">
      <div class="add_structure" (click)="goEdit()" *ngIf="!isUpdate">
        <fa-icon [icon]="getFaIcon('faPen')" appChangeColorTheme attribute="color"></fa-icon>
        <span>Editer</span>
      </div>
      <div class="search_bar" [style.width.%]="isUpdate? 100 : 50">
        <form [formGroup]="searchForm">
          <input type="text" placeholder="Chercher un club ..." (input)="applyFilter($event.target.value)"
            formControlName="keyword">

        </form>

        <fa-icon [icon]="getFaIcon('faTimes')" (click)="resetSearch()" class="faTimes" *ngIf="valueInput"></fa-icon>
        <fa-icon [icon]="getFaIcon('faSearch')" *ngIf="!valueInput"></fa-icon>

      </div>
    </div>
  </div>

  <div class="universes">
    <mat-radio-group [color]="color" aria-label="Select an option" class="univers_radio_button">
      <div class="label_radio_button">
        <mat-radio-button (click)="changeUniverse(1)" [checked]="universIsSelected(1)" value="1">Loisirs et Découvertes
        </mat-radio-button>
      </div>

      <div class="label_radio_button">
        <mat-radio-button (click)="changeUniverse(2)" [checked]="universIsSelected(2)"
          value="2">Compétitions</mat-radio-button>
      </div>

      <div class="label_radio_button">
        <mat-radio-button (click)="changeUniverse(3)" [checked]="universIsSelected(3)" value="3">Formation
          Professionnelle</mat-radio-button>
      </div>

      <div class="label_radio_button">
        <mat-radio-button (click)="changeUniverse(4)" [checked]="universIsSelected(4)"
          value="4">Entreprises</mat-radio-button>
      </div>

      <div class="label_radio_button">
        <mat-radio-button (click)="changeUniverse(6)" [checked]="universIsSelected(6)" value="6">Apprendre et se
          perfectionner</mat-radio-button>
      </div>
    </mat-radio-group>
  </div>

  <div class="link_structure">
    <div class="link">
      <mat-form-field appearance="outline">
        <mat-label>Url structure</mat-label>
        <input matInput type="text" [value]="getUrl()" readonly #link_url>
        <button matSuffix mat-icon-button aria-label="Clear" (click)="copyString(getUrl())" matTooltip="Copier">
          <fa-icon [icon]="getFaIcon('faCopy')" class="faCopy"></fa-icon>
        </button>
      </mat-form-field>

    </div>
    <div class="link">
      <mat-form-field appearance="outline">
        <mat-label>Code d'intégration avec recherche</mat-label>
        <input matInput type="text" [value]="getEmbedCodeWithSearch()" readonly #link_iframeWithSearch>
        <button matSuffix mat-icon-button aria-label="Clear" (click)="copyString(getEmbedCodeWithSearch())"
          matTooltip="Copier">
          <fa-icon [icon]="getFaIcon('faCopy')" class="faCopy"></fa-icon>
        </button>
      </mat-form-field>
    </div>

    <div class="link">
      <mat-form-field appearance="outline">
        <mat-label>Code d'intégration sans recherche</mat-label>
        <input matInput type="text" [value]="getEmbedCodeWithOutSearch()" readonly #link_iframeWithOutSearch>
        <button matSuffix mat-icon-button aria-label="Clear" (click)="copyString(getEmbedCodeWithOutSearch())"
          matTooltip="Copier">
          <fa-icon [icon]="getFaIcon('faCopy')" class="faCopy"></fa-icon>
        </button>
      </mat-form-field>

    </div>
  </div>



  <div class="content" *ngIf="!showEditStructure">
    <table mat-table [dataSource]="dataSource" matSort multiTemplateDataRows class="mat-elevation-z8">

      <ng-container matColumnDef="clubCode">
        <th mat-header-cell *matHeaderCellDef mat-sort-header="clubCode" class="cell_code_club"> Code
        </th>
        <td mat-cell *matCellDef="let element" class="cell_code_club"> {{element?.clubCode}} </td>
      </ng-container>

      <ng-container matColumnDef="clubName">
        <th mat-header-cell *matHeaderCellDef mat-sort-header="clubName" class="cell_club">Nom du club </th>
        <td mat-cell *matCellDef="let element" class="cell_club"> {{element?.clubName}} </td>
      </ng-container>

      <ng-container matColumnDef="isActive" *ngIf="isUpdate">
        <th mat-header-cell mat-sort-header="isActive" *matHeaderCellDef class="cell_action"
          [style.text-align]="'right !important'"> Act./Dés. </th>
        <td mat-cell *matCellDef="let element" class="cell_action">
          <mat-slide-toggle size="large" (toggleChange)="addOrDeleteCLub(element)" [color]="color"
            [checked]="clubISelected(element)"></mat-slide-toggle>
        </td>
      </ng-container>


      <tr mat-header-row *matHeaderRowDef=" !isUpdate?  displayedColumns: displayedColumnsUpdate"></tr>
      <tr mat-row *matRowDef="let row; columns: !isUpdate?  displayedColumns: displayedColumnsUpdate;">
      </tr>
    </table>
    <mat-paginator [length]="length" [pageSize]="pageSize" [pageSizeOptions]="pageSizeOptions"
      (page)="pageEvent = $event" [color]="color">
    </mat-paginator>
  </div>
</div>